import { FC } from 'react';
import { useField } from 'react-final-form';

import { FormCheckbox } from 'src/components/FormCheckbox/FormCheckbox';

export const NeedPassCheckbox: FC = () => {
  const guest = useField<boolean>('guest').input.value;

  return guest ? null : (
    <FormCheckbox name='needPass' label='Требуется пропуск' />
  );
};
